import { scheduledMeetingActions } from './scheduled-meeting.actions';
import { CoreAppState } from '../core-app.state';
import {
  BaseResourceState,
  createBaseResourceReducer,
  initialResourceState,
} from '../create-base-resource-reducer';
import { ScheduledMeetingResourceTypeMappings } from '@aa/nest/resource';

export type ScheduledMeetingState =
  BaseResourceState<ScheduledMeetingResourceTypeMappings>;
export const initialScheduledMeetingState: ScheduledMeetingState =
  initialResourceState;

export const scheduledMeetingReducer = createBaseResourceReducer<
  ScheduledMeetingResourceTypeMappings,
  ScheduledMeetingState
>(initialScheduledMeetingState, scheduledMeetingActions);

export const selectScheduledMeetingState = (state: CoreAppState) =>
  state.scheduledMeeting ?? initialScheduledMeetingState;
